module.exports = __webpack_public_path__ + "img/icon_heart_7.ec3a5b45.svg";